import React, { useState, useRef } from "react"
import styles from "./CustomCarousel.module.scss"

export const CustomCarousel = ({ children, showArrows = true, className = "" }) => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [isTransitioning, setIsTransitioning] = useState(false)
  const totalSlides = React.Children.count(children)
  const slideContainerRef = useRef(null)

  const goToPrevSlide = () => {
    if (isTransitioning || totalSlides <= 1) return

    setIsTransitioning(true)
    setCurrentSlide((prev) => (prev === 0 ? totalSlides - 1 : prev - 1))

    setTimeout(() => {
      setIsTransitioning(false)
    }, 300) 
  }

  const goToNextSlide = () => {
    if (isTransitioning || totalSlides <= 1) return

    setIsTransitioning(true)
    setCurrentSlide((prev) => (prev === totalSlides - 1 ? 0 : prev + 1))

    setTimeout(() => {
      setIsTransitioning(false)
    }, 300) 
  }

  const goToSlide = (index) => {
    if (isTransitioning || index === currentSlide || totalSlides <= 1) return

    setIsTransitioning(true)
    setCurrentSlide(index)

    setTimeout(() => {
      setIsTransitioning(false)
    }, 300)
  }

  const touchStartX = useRef(0)
  const touchEndX = useRef(0)

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX
  }

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX
  }

  const handleTouchEnd = () => {
    const diff = touchStartX.current - touchEndX.current
    const threshold = 50 

    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        goToNextSlide()
      } else {
        goToPrevSlide()
      }
    }
  }

  return (
    <div className={`${styles.carouselContainer} ${className}`}>
      <div
        className={styles.slidesWrapper}
        ref={slideContainerRef}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div
          className={styles.slidesTrack}
          style={{
            transform: `translateX(-${currentSlide * 100}%)`,
            transition: isTransitioning ? "transform 0.3s ease-in-out" : "none",
          }}
        >
          {React.Children.map(children, (child, index) => (
            <div className={styles.slide} key={index}>
              {child}
            </div>
          ))}
        </div>
      </div>

      {showArrows && totalSlides > 1 && (
        <>
          <button
            className={`${styles.arrowButton} ${styles.prevButton}`}
            onClick={goToPrevSlide}
            aria-label="Previous slide"
            type="button"
          >
            <svg className={styles.arrowIcon} viewBox="0 0 24 24">
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>
          <button
            className={`${styles.arrowButton} ${styles.nextButton}`}
            onClick={goToNextSlide}
            aria-label="Next slide"
            type="button"
          >
            <svg className={styles.arrowIcon} viewBox="0 0 24 24">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>
        </>
      )}

      {totalSlides > 1 && (
        <div className={styles.indicators}>
          {Array.from({ length: totalSlides }).map((_, index) => (
            <button
              key={index}
              className={`${styles.indicator} ${currentSlide === index ? styles.activeIndicator : ""}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
              type="button"
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default CustomCarousel







